export default "__VITE_ASSET__EUIXkYxJ__"